import { useMemo } from "react";

import useProp from "@/modules/cms/views/post/components/builder/hooks/useProp";
import { templateAlias } from "@/modules/path/views/pages/components/formUtils";
import createContextFactory from "@/utils/factory";

const { Provider, useContext } = createContextFactory(() => {
  const page = useProp()

  return useMemo(() => ({
    page,
  }), [page])
})

export function useTCPAQuestion() {
  const { page: { value: page } } = useContext()

  if (!page?.id) return null

  const { type, integrationData: { [templateAlias[type]]: tcpaquestion } } = page

  return tcpaquestion
}

export {
  Provider as MidpathProvider,
  useContext as useMidpathContext,
}
